export default __webpack_public_path__ + "static/media/sidebar-report.93395ed7.svg";